import { render, staticRenderFns } from "./TechModelTippyContainer.vue?vue&type=template&id=164c9010&"
import script from "./TechModelTippyContainer.vue?vue&type=script&lang=js&"
export * from "./TechModelTippyContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports